import type { FetchBaseQueryArgs } from "@reduxjs/toolkit/query"
import type { BaseQueryFn, FetchArgs, FetchBaseQueryError } from "@reduxjs/toolkit/query/react"
import { fetchBaseQuery } from "@reduxjs/toolkit/query/react"
import { Mutex } from "async-mutex"
import { format } from "date-fns"

export const customFetchBaseQuery = (props: FetchBaseQueryArgs) => {
  return fetchBaseQuery({
    ...props,
    baseUrl: `${import.meta.env.VITE_BACKEND_URL}${props.baseUrl}`,
    credentials: "include",
  })
}
const mutex = new Mutex()
const baseRefreshQuery = customFetchBaseQuery({ baseUrl: "/" })

export const baseQueryWithReauth = (
  props: FetchBaseQueryArgs,
): BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> => {
  const baseQuery = customFetchBaseQuery(props)
  return async (args, api, extraOptions) => {
    await mutex.waitForUnlock()
    let result = await baseQuery(args, api, extraOptions)

    if (result?.error?.status === 401) {
      // Try to refresh the token
      if (!mutex.isLocked()) {
        const release = await mutex.acquire()
        try {
          const refreshResult = await baseRefreshQuery({ url: "/api/auth/refresh", method: "POST" }, api, extraOptions)
          if (refreshResult?.data) {
            // Store the new auth state

            // Retry the original request
            result = await baseQuery(args, api, extraOptions)
          } else if (!window.location.href.endsWith("/login")) {
            console.log("location", window.location.href, import.meta.env.BASE_URL)
            window.location.href = "/login" // Redirect to login if refresh fails
          }
        } finally {
          // release must be called once the mutex should be released again.
          release()
        }
      } else {
        // wait until the mutex is available without locking it
        await mutex.waitForUnlock()
        result = await baseQuery(args, api, extraOptions)
      }
    }
    return result
  }
}

export const formatDate = (date: Date) => {
  return format(date, "yyyy.MM.dd")
}
